import Store from '../store';

export default {
  getViewPortSize() {
    let width = 0;
    width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    // var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    if (width < 576) {
      return 'xs';
    } else if (width >= 576 && width < 768) {
      return 'sm';
    } else if (width >= 768 && width < 992) {
      return 'md';
    } else if (width >= 992 && width < 1200) {
      return 'lg';
    } else if (width >= 1200) {
      return 'xl';
    }
    return false;
  },
  setResizeEvent() {
    Store.commit('setViewPortSize', this.getViewPortSize());
    Store.commit('setResizeWidth', Math.max(document.documentElement.clientWidth, window.innerWidth || 0));
    window.onresize = () => {
      Store.commit('setViewPortSize', this.getViewPortSize());
      Store.commit('setResizeWidth', Math.max(document.documentElement.clientWidth, window.innerWidth || 0));
    };
  },
};



// WEBPACK FOOTER //
// ./src/services/ViewPortService.js